export enum LEARNER_SCORE {
  LESSONS = 'lessons',
  ASSESSMENTS = 'assessments',
}

export enum LESSON {
  RESULT = 'result',
  EXERCISES = 'exercises',
}

export enum ASSESSMENT {
  RESULT = 'result',
  FUNCTIONAL = 'functional',
}

export enum ClassStatus {
  'On going' = 0,
  'Not started' = 1,
  'Completed' = 2,
}

export enum LessonAssessmentType {
  ASSESSMENTS = 'assessment',
  LESSONS = 'lesson',
}

export enum LearnerResultStatus {
  'Not started' = 0,
  'Completed' = 1,
  'In progress' = 2,
  'Missed' = 3,
}

export enum ExerciseContentType {
  DIY = 'diy',
  SUPERVISED = 'supervised',
}

export enum ClassLessonAction {
  STARTED,
  STOPPED,
}
